const invalidateCollection = () => (state) => {
  return Object.assign({}, state, { isStale: true })
}

export default invalidateCollection
